import store from '@/store';

export function useStore() {
  return {
    // TODO: Fix store typing
    store: store as any,
  };
}
